<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Additional Services</h1>
      </div>

      <form id="form10" autocomplete="off" class="mt-40">
        
        <div class="container w-100" style="font-size: 18px">
          
          <p class="text-center mb-20">
            Are there any specific services that you require assistance with?<br/>
            Select any of the services listed below and we will arrange for someone to contact you.
          </p>

          <div class="m-auto pl-20 pr-20" style="max-width: 500px;">

            <div class="row flx align-items-center mb-10">
              <label><input type="checkbox" class=""> Insurance and asset protection</label>
            </div>
            <div class="row flx align-items-center mb-10">
              <label><input type="checkbox" class=""> Investment, superannuation and financial planning</label>
            </div>
            <div class="row flx align-items-center mb-10">
              <label><input type="checkbox" class=""> Property buying advocacy</label>
            </div>
            <div class="row flx align-items-center mb-10">
              <label><input type="checkbox" class=""> Estate planning</label>
            </div>
            <div class="row flx align-items-center mb-10">
              <label><input type="checkbox" class=""> Property investment</label>
            </div>
            <div class="row flx align-items-center mb-10">
              <label><input type="checkbox" class=""> Coveyancing</label>
            </div>

          </div>
        
        </div>
        
      </form>

    </div>

    
    <div class="flx loan-container mt-60">
        <a type="button" class="continue-btn continue-btn-small steps-btn"
            href="#" @click.prevent="onContinue('post-settlement')">BACK</a>
        <a type="button"
            class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
            href="#" @click.prevent="onContinue('loan-application-summary')">CONTINUE</a>
    </div>
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>
